import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";

import { AddTenantRequest } from "@/types/request/AddTenantRequest";
import { UpdateTenantSettingsRequest } from "@/types/request/UpdateTenantSettingsRequest";
import { AddTenantResponse } from "@/types/response/AddTenantResponse";
import { GetTenantsResponse } from "@/types/response/GetTenantsResponse";
import { TenantType } from "@/types/tenant/TenantType";

export type TenantContextType = {
    addTenant: UseMutationResult<AxiosResponse<AddTenantResponse>, AxiosError, AddTenantRequest> ;
    tenant: TenantType | undefined;
    tenantLoading: boolean;
    tenants: GetTenantsResponse | undefined;
    tenantsFetching: boolean;
    tenantsLoading: boolean;
    updateTenantSettings: UseMutationResult<AxiosResponse<AddTenantResponse>, AxiosError, UpdateTenantSettingsRequest>
}

export const TenantContext = createContext<TenantContextType | null>(null);